module.exports = __webpack_public_path__ + "static/media/icon_group.c05a62af.svg";